// extracted by mini-css-extract-plugin
export var dropdownContainer = "_58-5";
export var imageContainer = "_58-4";
export var metricsGrid = "_58-2";
export var productDetailContainer = "_58-1";
export var productListContainer = "_58-0";
export var subscriberTableContainer = "_58-3";